import useStyles from 'isomorphic-style-loader/useStyles';
import { List } from 'semantic-ui-react';

import s from './social-icons.scss';

export const SocialIcons = () => {
  useStyles(s);

  return (
    <List horizontal className={s.root}>
      <List.Item
        as="a"
        href="https://anchore.com"
        target="_blank"
        rel="noopener noreferrer"
        className={s.anchoreIconSmall}
      />
      <List.Item
        as="a"
        href="https://x.com/anchore"
        target="_blank"
        rel="noopener noreferrer"
        className={s.xIconSmall}
      />
      <List.Item
        as="a"
        href="https://facebook.com/anchore"
        target="_blank"
        rel="noopener noreferrer"
      >
        <List.Icon
          inverted
          link
          name="facebook square"
          size="large"
          className={s.socialIcon}
        />
      </List.Item>
      <List.Item
        as="a"
        href="https://linkedin.com/company/anchore"
        target="_blank"
        rel="noopener noreferrer"
      >
        <List.Icon
          inverted
          link
          name="linkedin square"
          size="large"
          className={s.socialIcon}
        />
      </List.Item>
      <List.Item
        as="a"
        href="https://github.com/anchore"
        target="_blank"
        rel="noopener noreferrer"
      >
        <List.Icon
          inverted
          link
          name="github"
          size="large"
          className={s.socialIcon}
        />
      </List.Item>
    </List>
  );
};
